import { AnimationBuilder, AnimationFactory, animate, keyframes, query, sequence, style } from '@angular/animations';
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, inject } from '@angular/core';

import { WINDOW } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-my-bets-scoreboard-soccer-goal',
    template: `
        <div #indicator class="goal_indicator">
            <div class="inner">GOAL</div>
        </div>
    `,
    standalone: false,
})
export class MyBetsScoreboardSoccerGoalComponent implements OnInit, OnChanges, OnDestroy {
    private animationBuilder = inject(AnimationBuilder);
    private readonly _window = inject(WINDOW);
    private animationTimer = 0;
    @Input() score: number;
    @ViewChild('indicator', { static: true }) indicator: ElementRef;

    private animationFactory: AnimationFactory | null = null;

    ngOnInit(): void {
        this.animationFactory = this.animationBuilder.build([
            sequence([
                animate(
                    '0.5s ease-out',
                    keyframes([
                        style({ opacity: 0.5, right: '-{{right}}px', offset: 0 }),
                        style({
                            opacity: 1,
                            right: '0px',
                            offset: 1,
                        }),
                    ]),
                ),
                query(
                    '.inner',
                    animate(
                        '1.5s linear',
                        keyframes([
                            style({ opacity: 0 }),
                            style({ opacity: 1 }),
                            style({ opacity: 0 }),
                            style({ opacity: 1 }),
                            style({ opacity: 0 }),
                            style({ opacity: 1 }),
                        ]),
                    ),
                ),
            ]),
        ]);
    }

    private doAnimation(previousValue: number, currentValue: number): void {
        if (previousValue < currentValue && this.animationFactory) {
            this.animationTimer = this._window.setTimeout(() => {
                // Remove the indicator in 4s
                this.indicator.nativeElement.style.display = 'none';
            }, 5000);

            try {
                this.indicator.nativeElement.style.display = 'inline-block';
                const right = this.indicator.nativeElement.offsetWidth || 50;
                const player = this.animationFactory.create(this.indicator.nativeElement, { params: { right: right + 20 } });
                player.play();
            } catch {}
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('score' in changes && !changes['score'].isFirstChange()) {
            this.doAnimation(changes['score'].previousValue, changes['score'].currentValue);
        }
    }

    ngOnDestroy(): void {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
            this.animationTimer = 0;
        }
    }
}
